import { environment } from '@bvl-admin/environments/environment';

export class CommentEndpoint {
  public static saveComment = `${environment.LOAD_BALANCER}/comment`;
  public static commentsByIdPage = `${environment.LOAD_BALANCER}/comment/page/{idPage}`;
}
